/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class CustomTranslateLoader implements TranslateLoader {
    constructor(private http: HttpClient) { }

    getTranslation(lang: string): Observable<any> {
        lang = (lang && lang !== 'null') ? lang.toLowerCase() : 'en_us';
        return Observable.create((observer: any) => {
            if(localStorage.getItem('clientTranslationSetting') == 'true'){
                this.http.get(environment.host + '/translation/' + lang).subscribe((res: any) => {
                    if (res) {
                        observer.next(JSON.parse(decodeURIComponent(escape(window.atob(res)))));
                        observer.complete();
                    }else{
                        observer.next(res);
                        observer.complete();
                    }
                });
                localStorage.setItem('clientTranslationSetting', 'false');
            }else{
                this.http.get(`./i18n/${lang}.json`).subscribe((res: any) => {
                    observer.next(res);
                    observer.complete();
                });
            }
        });
        
    }
}

/*This is Approach2, its working but code is lengthy, To test this comment above loader and uncomment below code */
// @Injectable()
// export class CustomTranslateLoader implements TranslateLoader {
//     constructor(private http: HttpClient) { }
//     getTranslation(lang: string): Observable<any> {
//         lang = (lang && lang !== 'null') ? lang.toLowerCase() : 'en';
//         let companyTransCode = '';

//         const userDetails = JSON.parse(localStorage.getItem('userDetails'));
//         if (userDetails && userDetails.company && userDetails.company.code) {
//             companyTransCode = COMPANY_TRANSLATION_CODES[userDetails.company.code]
//         }
//         return Observable.create(observer => {
//             this.http.get(environment.host + '/translation1/' + lang).subscribe((res: any) => {
//                 if (res) {
//                     let decodedRes = JSON.parse(decodeURIComponent(escape(window.atob(res))));
//                     if(companyTransCode && companyTransCode != lang){
//                         this.http.get(`./i18n/${companyTransCode}.json`).subscribe((clientRes: Response) => { /* Getting client json */
//                             $.extend( true, decodedRes, clientRes ); /* Merging client response with default language response */
//                             observer.next(decodedRes); /* Here 'decodedRes' object will have merged result of client and default language json files */
//                             observer.complete();
//                         });
//                     }
//                     else{
//                         observer.next(decodedRes);
//                         observer.complete();
//                     }
//                 } else {
//                     this.http.get(`./i18n/${lang}.json`).subscribe((res: Response) => {
//                         if(companyTransCode && companyTransCode != lang){
//                             this.http.get(`./i18n/${companyTransCode}.json`).subscribe((clientRes: Response) => { /* Getting client json */
//                                 $.extend( true, res, clientRes ); /* Merging client response with default language response */
//                                 observer.next(res); /* Here 'decodedRes' object will have merged result of client and default language json files */
//                                 observer.complete();
//                             });
//                         }
//                         else{
//                             observer.next(res);
//                             observer.complete();
//                         }
//                     });
//                 }
//             },
//             error => {
//                 //  failed to retrieve from api, switch to local
//                 this.http.get(`./i18n/${lang}.json`).subscribe((res: Response) => {
//                     if(companyTransCode && companyTransCode != lang){
//                         this.http.get(`./i18n/${companyTransCode}.json`).subscribe((clientRes: Response) => { /* Getting client json */
//                             $.extend( true, res, clientRes ); /* Merging client response with default language response */
//                             observer.next(res); /* Here 'decodedRes' object will have merged result of client and default language json files */
//                             observer.complete();
//                         });
//                     }
//                     else{
//                         observer.next(res);
//                         observer.complete();
//                     }
//                 });
//             }
//             );
//         });
//     }
// }